import { PageWrapper } from '@/components/page-wrapper/page-wrapper';
import OnboardingCarousel from './onboarding-carousel';

// TODO(connect-ds): Replace the native page layout when Connect provides an equivalent container.
export const HomePage = () => (
  <PageWrapper
    headerProps={{}}
    layout="fill"
    contentPaddingX={0}
    maxWidth="100%"
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        padding: 0,
        width: '100%',
      }}
    >
      <OnboardingCarousel />
    </div>
  </PageWrapper>
);
